import { produce } from "immer";
import { AnyAction } from "redux";

import { IResponseStatus, MessageResponse } from "../../../_helpers/iResponse";
import { convertKeysToCamelCase } from "../../../_helpers/stringHelper";
import { ConstructionPeriod } from "../../../common/enums/sharedEnums";
import { IDwelling, IServiceAgency } from "../../dwelling/reducers";
import { IFile, IService } from "../../serviceOrdering/reducers";
import {
  GET_BUILDING_DWELLINGS_SUCCESS,
  GET_BUILDING_SUCCESS,
  GET_BUILDINGS_SUCCESS,
} from "../constants";
import { IAddress } from "../interfaces";

export interface IBuilding {
  agency: IServiceAgency;
  datedReference?: string;
  files?: IFile[];
  id?: string;
  buildingNumber?: number;
  cadastralReference?: string;
  condominiumNumber?: string;
  condominiumSyndicate?: string;
  constructionPeriod?: ConstructionPeriod;
  constructionDate?: string;
  entryNumber?: number;
  floorNumber?: number;
  internalReference?: string;
  isCollective?: boolean;
  isCondominium?: boolean;
  isTermiteZone?: boolean;
  lessorName?: string;
  managementLotNumber?: number;
  address: IAddress;
  documents?: any[];
  dwellings?: IDwelling[];
  services?: IService[];
  agencyId: string;
  // society: ISociety
  permissions: string[];
  pictures: string[];
}

export interface IResponseBuildings {
  buildings?: Array<IBuilding>;
  count: number;
  currentPage: number;
}
export interface IResponseBuilding extends IResponseStatus {
  data: {
    data?: {
      id?: string;
      count?: number;
      building?: IBuilding;
      buildings?: Array<IBuilding>;
    };
    message: MessageResponse;
  };
}

export interface IResponsePaginateServices {
  buildings: Array<IBuilding>;
  perPage: number;
  currentPage: number;
  firstPage: number;
  total?: number;
  count?: number;
  lastPage: number;
}

const initState = {
  building: null,
  buildingDwellings: null,
  buildingDwellingsCount: null,
  buildings: null,
  buildingsCount: null,
};

const buildingReducer = produce((draft = initState, action: AnyAction) => {
  switch (action.type) {
    case GET_BUILDINGS_SUCCESS:
      draft.buildings = action.payload.buildings;
      draft.buildingsCount = action.payload.count;
      break;
    case GET_BUILDING_SUCCESS:
      draft.building = convertKeysToCamelCase(action.payload);
      break;
    case GET_BUILDING_DWELLINGS_SUCCESS:
      draft.buildingDwellings = action.payload.dwellings;
      draft.buildingDwellingsCount = action.payload.count;
      break;
    default:
      return draft;
  }
});

export default buildingReducer;
